import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { InsuranceFile } from './dealership/InsuranceFile';
import { UserProfile } from './UserProfile';

import axios from 'axios'
import useGlobalState, { g_user, API_Root } from "../globalState";
import './DealerAdmin.css';

export const DealerAdmin = () => {
   const [users, setUsers] = useState([]);
   const [invoiceSettings, setInvoiceSettings] = useState([]);
   const [showAddUser, setShowAddUser] = useState(false);
   const [addEmail, setAddEmail] = useState('');
   const [addType, setAddType] = useState('');
   const [rateType, setRateType] = useState(null);
   const [rateTypes, setRateTypes] = useState([]);
   const [invoiceSetting, setInvoiceSetting] = useState(null);
   const [invoiceEmail, setInvoiceEmail] = useState('');
   const [rate, setRate] = useState(null);
   const [minFee, setMinFee] = useState(null);
   const [settingsOnFile, setSettingsOnFile] = useState(null);
   const [autoAssign, setAutoAssign] = useState(false);
   const [delay, setDelay] = useState(null);
   const [insuranceFile, setInsuranceFile] = useState(0);
   const [replyEmail, setReplyEmail] = useState('');
   const [curDealership, setCurDealership] = useState(undefined);
   const [init, setInit] = useState(false);
   const [user] = useGlobalState(g_user);
   const [editUser, setEditUser] = useState();
   const [userRate, setUserRate] = useState();
   const [userRateMethod, setUserRateMethod] = useState();
   const [showEditUser, setShowEditUser] = useState(false);
   const [showProfile, setShowProfile] = useState(false);
   const [userToShowProfile, setUserToShowProfile] = useState(0);
   const [saving, setSaving] = useState(false);
   const [usersLoading, setUsersLoading] = useState(true);
   const toast = useRef(null);

   useEffect(() => {
      if (!init) {
         setInit(true);
         selectDealership(user.adminDealerships[0]);
         let rt = [{ id: 'm', name: 'Per Mile' },
            { id: 'h', name: 'Per Hour' }];

         setRateTypes(rt);
         getInvoiceSettings();
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const dealerName = curDealership?.dealershipName || 'your dealership';

   const getDealershipDropdown = () => {
      if (user?.adminDealerships !== undefined && user?.adminDealerships?.length > 1) {
         return <div className="dealer-admin-dealer">
            <label htmlFor="dealerships">Dealership</label>
            <Dropdown id="dealerships" value={curDealership} onChange={(e) => selectDealership(e.value)} options={user.adminDealerships} optionLabel="dealershipName"
               placeholder="Select a dealership" />
         </div>;
      }
      return null;
   }

   const selectDealership = (sel) => {
      setCurDealership(sel);
      getUsersForDealership(sel?.id);
      getSettings(sel?.id);
   }

   const getUsersForDealership = (id) => {
      setUsersLoading(true);
      if (!id) {
         setUsers([]);
         setUsersLoading(false);
         return;
      }
      var apiUrl = `${API_Root}api/dealership/getUsers?id=${id}`;
      axios.get(apiUrl).then((values) => {
         setUsers(values.data || []);
      }).catch(() => {
         setUsers([]);
      }).finally(() => {
         setUsersLoading(false);
      });
   }

   const getInvoiceSettings = (id) => {
      var apiUrl = `${API_Root}api/dealership/GetInvoiceSettings`;
      axios.get(apiUrl).then((values) => {
         setInvoiceSettings(values.data);
      });
   }

   const clearSettings = () => {
      setRateType(null);
      setRate(null);
      setReplyEmail('');
      setAutoAssign(false);
      setDelay(null);
      setMinFee(null);
      setInvoiceSetting(null);
      setInvoiceEmail('');
      setInsuranceFile(null);
   }

   const getSettings = (id) => {
      clearSettings();
      setSettingsOnFile(null);

      var apiUrl = `${API_Root}api/dealership/getSettings?id=${id}`;
      axios.get(apiUrl).then((values) => {
         let settings = values.data;
         if (settings) {
            setRateType(settings.rateMethod);
            setRate(settings.rate);
            setReplyEmail(settings.replyEmailAddress ?? '');
            setAutoAssign(settings.autoAssignment);
            setDelay(settings.autoAssignDelayMinutes);
            setMinFee(settings.minFee);
            setInvoiceSetting(settings.invoiceSettingId);
            setInvoiceEmail(settings.invoiceEmail ?? '');
            setInsuranceFile(settings.insuranceCardFile);
            setSettingsOnFile(true);
         } else {
            setSettingsOnFile(false);
         }
      }).catch(() => {
         setSettingsOnFile(false);
      });
   }

   const saveSettings = () => {
      if (!rateType || rate == null || rate === '' || minFee == null || minFee === '' || !invoiceSetting) {
         toast.current?.show({ severity: 'error', summary: 'Enter a rate type, rate, minimum fee, and invoicing type', life: 4000 });
         return;
      }

      var apiUrl = `${API_Root}api/dealership/saveSettings`;

      var dto = {
         dealershipId: curDealership.id,
         rateMethod: rateType,
         rate: Number(rate),
         replyEmailAddress: replyEmail,
         autoAssignment: autoAssign,
         autoAssignDelayMinutes: delay == null || delay === '' ? 0 : Number(delay),
         minFee: Number(minFee),
         invoiceSettingId: invoiceSetting,
         invoiceEmail: invoiceEmail,
         insuranceCardFile: insuranceFile
      };

      setSaving(true);
      axios.post(apiUrl, dto).then(() => {
         setSettingsOnFile(true);
         toast.current?.show({ severity: 'success', summary: 'Settings saved', life: 3000 });
      }).catch(() => {
         toast.current?.show({ severity: 'error', summary: 'Could not save settings', life: 4000 });
      }).finally(() => {
         setSaving(false);
      });
   }

   const deleteUser = (id) => {
      var apiUrl = `${API_Root}api/dealership/deleteUserReference?id=${id}`;
      axios.get(apiUrl).then((values) => {
         getUsersForDealership(curDealership.id);
      });
   }

   const addUser = () => {
      var apiUrl = `${API_Root}api/user/AddDealershipUser?email=${addEmail}&dealerId=${curDealership.id}&type=${addType}`;
      axios.get(apiUrl).then((values) => {
         setShowAddUser(false);
         setAddEmail('');
         setAddType('');
         getUsersForDealership(curDealership.id);
         toast.current?.show({ severity: 'success', summary: 'User added', life: 3000 });
      }).catch(() => {
         toast.current?.show({ severity: 'error', summary: 'Could not add user', life: 4000 });
      });
   }

   const nameTemplate = (rowData) => {
      return <span className="dealer-admin-name">{`${rowData.firstName} ${rowData.lastName}`}</span>;
   };

   const typeTemplate = (rowData) => {
      if (rowData.isPorter) {
         return <Tag value="Driver" />;
      }
      return <Tag value="Admin" severity="secondary" />;
   };

   const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
   });

   const rateMethodLabel = (id) => {
      if (id === 'h') {
         return 'hour';
      }
      if (id === 'm') {
         return 'mile';
      }
      return id || '';
   };

   const defaultRateForType = (id) => (id === 'h' ? 15 : 0.35);

   const changeRateType = (id) => {
      setRateType(id);
   };

   const changeUserRateMethod = (id) => {
      const previousDefault = defaultRateForType(userRateMethod);
      setUserRateMethod(id);
      if (!userRate || userRate === previousDefault) {
         setUserRate(defaultRateForType(id));
      }
   };

   const editDealerUser = (user) => {
      setEditUser(user);
      setUserRate(user.rate);
      setUserRateMethod(user.rateMethod);
      setShowEditUser(true);
   }

   const saveDealerUser = () => {
      let user = editUser;
      user.rate = userRate;
      user.rateMethod = userRateMethod;

      var apiUrl = `${API_Root}api/dealership/updateUser`;
      axios.post(apiUrl, user).then((values) => {
         let newUsers = [...users];
         setUsers(newUsers);
         setShowEditUser(false);
         toast.current?.show({ severity: 'success', summary: 'Rate updated', life: 3000 });
      }).catch(() => {
         toast.current?.show({ severity: 'error', summary: 'Could not update rate', life: 4000 });
      });
   }

   const rateTemplate = (rowData) => {
      if (!rowData.isPorter) {
         return (<span className="text-color-secondary">—</span>);
      }

      let value = "Set rate";
      if (rowData.rate) {
         value = `${formatter.format(rowData.rate)} / ${rateMethodLabel(rowData.rateMethod)}`;
      }

      return (
         <button type="button" className="dealer-admin-rate" onClick={() => editDealerUser(rowData)}>
            <span>{value}</span>
            <i className="pi pi-pencil"></i>
         </button>
      );
   };

    const closeProfile = () => {
        setShowProfile(false);
        getUsersForDealership(curDealership.id);
    }

   const actionTemplate = (rowData) => {
      return (
         <div className="dealer-admin-actions">
            <Button rounded text icon="pi pi-user-edit" title="Edit profile" onClick={() => editUserProfile(rowData.userId)} />
            <Button rounded text severity="danger" icon="pi pi-trash" title="Remove user" onClick={() => deleteUser(rowData.referenceId)} />
         </div>
      );
   };

    const editUserProfile = (id) => {
        setUserToShowProfile(id);
        setShowProfile(true);
    }

   const emailClass = (value) => {
      return (value && !validateEmail(value)) ? 'p-invalid w-full' : 'w-full';
   }

   const invoicingFields = () => {
      return (
         <>
            <div className="dealer-admin-field">
               <label htmlFor="invoiceSetting">Invoicing type</label>
               <Dropdown id="invoiceSetting" value={invoiceSetting} onChange={(e) => setInvoiceSetting(e.value)} options={invoiceSettings} optionLabel="typeName" optionValue="id" placeholder="Not set" />
            </div>
            {invoiceSetting != null && invoiceSetting != 1 && (
               <div className="dealer-admin-field">
                  <label htmlFor="invoiceEmail">Send invoices to</label>
                  <InputText id="invoiceEmail" value={invoiceEmail} onChange={(e) => setInvoiceEmail(e.target.value)} className={emailClass(invoiceEmail)} />
               </div>
            )}
         </>
      );
   }

   const validateEmail = (e) => {
      return String(e)
         .toLowerCase()
         .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         );
   };

   const canAddUser = validateEmail(addEmail) && addType;
   const userCount = users?.length || 0;
   const rateSuffix = rateType === 'h' ? ' / hr' : rateType === 'm' ? ' / mi' : '';

   return (
      <div className="dealer-admin-page">
         <Toast ref={toast} />
         <div className="dealer-admin-header">
            <div>
               <h2 className="dealer-admin-title">Dealership admin</h2>
               <p className="dealer-admin-meta">Manage people, rates, and settings for {dealerName}</p>
            </div>
            {getDealershipDropdown()}
         </div>
         <TabView scrollable>
            <TabPanel header="Users">
               <div className="dealer-admin-toolbar">
                  <div>
                     <h3>People</h3>
                     <p>{userCount === 1 ? '1 person at this dealership' : `${userCount} people at this dealership`}</p>
                  </div>
                  <Button label="Add user" icon="pi pi-plus" onClick={() => setShowAddUser(true)} />
               </div>
               <DataTable
                  className="dealer-admin-table"
                  value={users}
                  stripedRows
                  breakpoint="768px"
                  loading={usersLoading}
                  emptyMessage={usersLoading ? 'Loading people…' : 'No users yet. Add a driver or admin to get started.'}>
                  <Column header="Name" body={nameTemplate} ></Column>
                  <Column header="Email" style={{ minWidth: '12rem' }} field="email" />
                  <Column header="Phone" style={{ minWidth: '10rem' }} field="phone" />
                  <Column header="Type" style={{ minWidth: '7rem' }} body={typeTemplate} />
                  <Column header="Rate" style={{ minWidth: '10rem' }} body={rateTemplate} />
                  <Column header="" style={{ width: '8rem' }} body={actionTemplate} />
               </DataTable>
            </TabPanel>
            <TabPanel header="Settings">
               <div className="dealer-admin-settings">
                  <section className="dealer-admin-card">
                     <div className="dealer-admin-card-head">
                        <div className="dealer-admin-card-icon"><i className="pi pi-send"></i></div>
                        <div>
                           <h3>Trip assignment</h3>
                           <p>How new trips are offered to drivers</p>
                        </div>
                     </div>
                     <div className="dealer-admin-fields">
                        <div className="dealer-admin-field">
                           <label>Automatic assignment</label>
                           <div className="dealer-admin-switch">
                              <InputSwitch checked={autoAssign} onChange={e => setAutoAssign(e.value)} />
                              <span className="dealer-admin-switch-label">{autoAssign ? 'On' : 'Off'}</span>
                           </div>
                           <p className="dealer-admin-hint">Offer trips to drivers without waiting for a claim</p>
                        </div>
                        <div className="dealer-admin-field">
                           <label htmlFor="delay">Delay (minutes)</label>
                           <InputNumber id="delay" value={delay} onValueChange={(e) => setDelay(e.value)} min={0} max={999} disabled={!autoAssign} placeholder="Minutes" />
                        </div>
                        <div className="dealer-admin-field dealer-admin-field-wide">
                           <label htmlFor="replyEmail">Reply-to email</label>
                           <InputText id="replyEmail" value={replyEmail} onChange={(e) => setReplyEmail(e.target.value)} className={emailClass(replyEmail)} />
                        </div>
                     </div>
                  </section>
                  <section className="dealer-admin-card">
                     <div className="dealer-admin-card-head">
                        <div className="dealer-admin-card-icon"><i className="pi pi-dollar"></i></div>
                        <div>
                           <h3>Billing</h3>
                           <p>Default rates and how invoices are sent</p>
                           {settingsOnFile === false ? (
                              <p className="dealer-admin-hint">No billing settings are saved for this dealership yet.</p>
                           ) : null}
                        </div>
                     </div>
                     <div className="dealer-admin-fields">
                        <div className="dealer-admin-field">
                           <label htmlFor="rateType">Rate type</label>
                           <Dropdown id="rateType" value={rateType} onChange={(e) => changeRateType(e.value)} options={rateTypes} optionLabel="name" optionValue="id" placeholder="Not set" />
                        </div>
                        <div className="dealer-admin-field">
                           <label htmlFor="rate">Rate</label>
                           <InputNumber id="rate" value={rate} onValueChange={(e) => setRate(e.value)} min={0} max={99} minFractionDigits={2} maxFractionDigits={2} prefix="$" suffix={rateSuffix} placeholder="Not set" />
                        </div>
                        <div className="dealer-admin-field">
                           <label htmlFor="minFee">Minimum fee</label>
                           <InputNumber id="minFee" value={minFee} onValueChange={(e) => setMinFee(e.value)} min={0} max={999} minFractionDigits={2} maxFractionDigits={2} mode="currency" currency="USD" locale="en-US" placeholder="Not set" />
                        </div>
                        {invoicingFields()}
                     </div>
                  </section>
                  <section className="dealer-admin-card dealer-admin-card-wide">
                     <div className="dealer-admin-card-head">
                        <div className="dealer-admin-card-icon"><i className="pi pi-id-card"></i></div>
                        <div>
                           <h3>Insurance</h3>
                           <p>Dealership insurance card on file</p>
                        </div>
                     </div>
                     <div className="dealer-admin-insurance">
                        <InsuranceFile dealership={curDealership} fileId={insuranceFile} updateFileId={(id) => setInsuranceFile(id) } />
                     </div>
                  </section>
                  <div className="dealer-admin-save">
                     <Button label="Save settings" icon="pi pi-save" onClick={() => saveSettings()} loading={saving} />
                  </div>
               </div>
            </TabPanel>
         </TabView>
         <Dialog
            className="dealer-admin-dialog"
            header="Edit user rate"
            visible={showEditUser}
            style={{ width: '28rem' }}
            breakpoints={{ '960px': '75vw', '641px': '95vw' }}
            onHide={() => setShowEditUser(false)}
            footer={
               <div className="dealer-admin-dialog-footer">
                  <Button label="Cancel" outlined onClick={() => setShowEditUser(false)} />
                  <Button label="Save" icon="pi pi-save" onClick={() => saveDealerUser()} />
               </div>
            }>
            <div className="dealer-admin-fields">
               <div className="dealer-admin-field">
                  <label htmlFor="userRateMethod">Rate type</label>
                  <Dropdown id="userRateMethod" value={userRateMethod} onChange={(e) => changeUserRateMethod(e.value)} options={rateTypes} optionLabel="name" optionValue="id" />
               </div>
               <div className="dealer-admin-field">
                  <label htmlFor="userRate">Rate</label>
                  <InputNumber id="userRate" value={userRate} onValueChange={(e) => setUserRate(e.value)} min={0} max={99} minFractionDigits={2} maxFractionDigits={2} prefix="$" suffix={userRateMethod === 'h' ? ' / hr' : ' / mi'} />
               </div>
            </div>
         </Dialog>
         <Dialog
            className="dealer-admin-dialog"
            header="Add dealership user"
            visible={showAddUser}
            style={{ width: '28rem' }}
            breakpoints={{ '960px': '75vw', '641px': '95vw' }}
            onHide={() => { setShowAddUser(false); setAddEmail(''); setAddType(''); }}
            footer={
               <div className="dealer-admin-dialog-footer">
                  <Button label="Cancel" outlined onClick={() => { setShowAddUser(false); setAddEmail(''); setAddType(''); }} />
                  <Button label="Add user" icon="pi pi-plus" onClick={() => addUser()} disabled={!canAddUser} />
               </div>
            }>
            <div className="dealer-admin-fields" style={{ gridTemplateColumns: '1fr' }}>
               <div className="dealer-admin-field dealer-admin-field-wide">
                  <label htmlFor="addemail">Email address</label>
                  <InputText
                     id="addemail"
                     placeholder="name@example.com"
                     value={addEmail}
                     onChange={(e) => setAddEmail(e.target.value)}
                     className={emailClass(addEmail)} />
               </div>
               <div className="dealer-admin-field dealer-admin-field-wide">
                  <label>Role</label>
                  <div className="dealer-admin-role-picks">
                     <div
                        className={`dealer-admin-role${addType === 'p' ? ' is-selected' : ''}`}
                        onClick={() => setAddType('p')}>
                        <i className="pi pi-car"></i>
                        <span>Driver</span>
                     </div>
                     <div
                        className={`dealer-admin-role${addType === 'a' ? ' is-selected' : ''}`}
                        onClick={() => setAddType('a')}>
                        <i className="pi pi-briefcase"></i>
                        <span>Admin</span>
                     </div>
                  </div>
               </div>
            </div>
         </Dialog>
           <Dialog className="dealer-admin-dialog" header="User Profile" visible={showProfile} style={{ width: '80vw' }} breakpoints={{ '960px': '95vw', '641px': '100vw' }} onHide={() => setShowProfile(false)}>
               <UserProfile userId={userToShowProfile} onClose={() => closeProfile()}></UserProfile>
           </Dialog>
      </div>
   );
}
